import { render, staticRenderFns } from "./LibraryBooks.vue?vue&type=template&id=80aa9856&scoped=true&"
import script from "./LibraryBooks.vue?vue&type=script&lang=js&"
export * from "./LibraryBooks.vue?vue&type=script&lang=js&"
import style0 from "./LibraryBooks.vue?vue&type=style&index=0&id=80aa9856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80aa9856",
  null
  
)

export default component.exports